import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.function.name.js";
import { mixinItem } from '@/mixins/registerItem.js';
import Connect from '@/components/connect/connect';
import ShoppingCart from '@/components/shoppingCart/shoppingCart.vue';
import { switchChain, isSupportChain } from '@/utils/connect';
import { getFavoriteCount } from '@/utils/utils';
import UserInfo from '@/components/userInfo/userInfo.vue';
import EmailItem from '@/components/emailItem/emailItem.vue';
import WhatIsNew from '@/components/popup/whatIsNew.vue';
import ConnectWallet from '@/components/popup/connectWallet';
import Prompt from '@/components/popup/prompt';
import HeaderMore from '@/components/popup/headerMore';
import UnsupportedChain from '@/components/UnsupportedChain';
import CallbackPupop from './callbackPupop.vue';
import Register from '@/views/query/components/register';
import QueryApi from '@/api/modules/query';
import BigNumber from 'bignumber.js';
import { ethers } from 'ethers';
import { chainIdListFilter, signLogin } from '@/utils/connect';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import ServiceTerm from '@/components/popup/serviceTerms.vue';
import MailboxBinding from './mailboxBinding.vue';
import SigninApi from '@/api/modules/signin';
import CommomApi from '@/api/modules/commom';
import { getChainImages } from '@/utils/chainInfo';
import { localStorage } from '@/store/storage';
// import {account, disconnect, connect, accountDetails} from '@kolirt/vue-web3-auth'

export default {
  name: 'Header',
  components: {
    WhatIsNew: WhatIsNew,
    ServiceTerm: ServiceTerm,
    Connect: Connect,
    ShoppingCart: ShoppingCart,
    UserInfo: UserInfo,
    EmailItem: EmailItem,
    ConnectWallet: ConnectWallet,
    CallbackPupop: CallbackPupop,
    Register: Register,
    HeaderMore: HeaderMore,
    UnsupportedChain: UnsupportedChain,
    MailboxBinding: MailboxBinding
  },
  data: function data() {
    return {
      is_address: false,
      languageType: this.$store.state.language || 'en',
      showPicker: false,
      showPopover: false,
      showBindingBox: false,
      languageList: [{
        value: 'en',
        label: 'English'
      }, {
        value: 'ch',
        label: '繁體中文'
      }, {
        value: 'kr',
        label: '한국어'
      }, {
        value: 'jp',
        label: 'にほんご'
      }],
      moreActions: [{
        url: '',
        value: 'Docs',
        label: 'Docs'
      }, {
        url: '',
        value: 'Docs',
        label: 'FAQ'
      }],
      socailList: [{
        icon: require('@/assets/image/footer/icon_foot1.svg'),
        url: 'https://twitter.com/OpenNameDID'
      }, {
        icon: require('@/assets/image/footer/icon_foot2.svg'),
        url: 'https://discord.com/invite/G83NXk7YHp'
      }, {
        icon: require('@/assets/image/footer/icon_foot3.svg'),
        url: ''
      }, {
        icon: require('@/assets/image/footer/icon_foot4.svg'),
        url: ''
      }, {
        icon: require('@/assets/image/footer/icon_foot5.svg'),
        url: 'https://medium.com/@openname'
      }],
      searchName: '',
      chainId: this.$store.state.chainid || 1,
      shopVisible: false,
      userVisible: false,
      showCart: false,
      emailVisible: false,
      emailEdit: false,
      favoriteNumber: 0,
      nameListItem: [],
      isSelectChainFocus: false,
      gasPrice: 0,
      timer: null,
      infoStatus: false,
      unsupportChain: {
        icon: require('@/assets/image/connect/icon_unsupport_chain.png'),
        key: 'Unsupported Network',
        text: 'Unsupported Network',
        chainId: null
      },
      showPopupBox: false,
      chainIcon: getChainImages(),
      queryErrorMsg: 'NO data',
      chainid_sel: '',
      inputFlag: null,
      searchParmes: {
        pageNo: 1,
        pageSize: 20
      },
      selectDom: '',
      searchLoad: true,
      loadMore: false
    };
  },
  mixins: [mixinItem],
  watch: {
    $route: {
      handler: function handler(to, from) {
        this.resInfo();
      },
      deep: true,
      immediate: true
    },
    showConnect: {
      handler: function handler(to, from) {
        if (to) {
          this.$refs.connect.showConnect = true;
          this.$refs.connect.isSelectNet = true;
        }
      },
      deep: true,
      immediate: false
    },
    account: {
      handler: function handler(to, from) {
        if (to) {
          this.getTosAgree();
        }
      },
      deep: true,
      immediate: false
    },
    showSwitchChainPromt: {
      handler: function handler(to, from) {
        if (to) {
          this.$refs.chainTip.visible = true;
        }
      },
      deep: true,
      immediate: false
    },
    signConnect: {
      handler: function handler(to, from) {
        if (to) {
          if (this.$store.state.connectPosition == 15) {
            this.getConnectItem();
          } else {
            this.signLoginNowItem();
          }
        }
      },
      deep: true,
      immediate: false
    },
    chainid: {
      handler: function handler(to, from) {
        if (to) {
          if (to == '1' || to == '5') {
            this.getGasPrice();
          } else {
            if (this.timer) {
              clearInterval(this.timer);
              this.timer = null;
            }
          }
        }
      },
      deep: true,
      immediate: true
    },
    showUnsupported: {
      handler: function handler(to, from) {
        if (to) {
          this.$store.commit('setShowUnsupported', false);
          if (this.selChainId) {
            this.chainid_sel = this.selChainId;
            this.$store.commit('setSelChainId', '');
          }
          this.showPopupBox = true;
        }
      },
      deep: true,
      immediate: false
    }
  },
  computed: _objectSpread(_objectSpread({
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    },
    supportChainList: function supportChainList() {
      return function () {
        return chainIdListFilter();
      };
    }
  }, mapState(['showConnect', 'signConnect', 'registerShowItem', 'registerDomainItem', 'showUnsupported', 'chainid', 'selChainId', 'signConnectCallBackHeader', 'registerItem'])), {}, {
    routerList: function routerList() {
      return [
      // {path: "/namefi", name: this.$t(`header.name_fi`),icon:require('@/assets/image/nameFi/gold.gif')},
      {
        path: '/',
        name: this.$t("header.register"),
        icon: ''
      }, {
        path: '/pricing',
        name: this.$t("header.pricing"),
        icon: ''
      }, {
        path: '/invite',
        name: this.$t("header.invite"),
        icon: ''
      },
      // {path: "/activities", name: this.$t(`header.activities`)},
      {
        path: '',
        name: 'FAQ',
        url: 'https://docs.open.name/faq',
        icon: ''
      }];
    },
    currentChainIcon: function currentChainIcon() {
      try {
        if (this.$store.state.chainid) {
          if (isSupportChain() && this.chainIcon[this.$store.state.chainid]) {
            if (this.supportChainList().indexOf(this.unsupportChain) !== -1) {
              var index = this.supportChainList().indexOf(this.unsupportChain);
              this.supportChainList().splice(index, 1);
            }
            return this.chainIcon[this.$store.state.chainid];
          } else {
            this.unsupportChain.chainId = this.chainid;
            if (this.supportChainList().indexOf(this.unsupportChain) == -1) {
              this.supportChainList().unshift(this.unsupportChain);
            }
            return require('@/assets/image/connect/icon_unsupport_chain.png');
          }
        } else {
          return '';
        }
      } catch (error) {
        this.unsupportChain.chainId = this.chainid;
        if (this.supportChainList().indexOf(this.unsupportChain) == -1) {
          this.supportChainList().unshift(this.unsupportChain);
        }
        return require('@/assets/image/connect/icon_unsupport_chain.png');
      }
    },
    account: function account() {
      return this.$store.state.account ? this.$getAbbreviateAddress(this.$store.state.account) : this.$t("header.connect");
    },
    cartNumber: function cartNumber() {
      return this.$store.state.shoppingCartNumber;
    },
    addressName: function addressName(name) {
      return function (name) {
        return name.substr(0, 3) + '...' + name.substr(name.length - 3, 3);
      };
    }
  }),
  mounted: function mounted() {
    this.currentRouter = this.$route.path;
    this.getNoticeList();
  },
  methods: {
    resInfo: function resInfo() {
      this.searchParmes = {
        pageNo: 1,
        pageSize: 20
      };
      this.nameListItem = [];
      this.searchLoad = true;
      this.loadMore = false;
      this.selectDom = '';
    },
    successBack: function successBack(name) {
      this.$router.push({
        path: '/myName'
      });
    },
    handleScroll: function handleScroll(e) {
      var scrollTop = e.target.scrollTop;
      var clientHeight = e.target.clientHeight;
      var scrollHeight = e.target.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        if (this.searchLoad && !this.loadMore) {
          this.searchParmes.pageNo = this.searchParmes.pageNo + 1;
          this.handleSearchName(this.searchName, 1);
        }
      }
    },
    slectDiaName: function slectDiaName() {},
    showbox: function showbox() {
      if (!this.isMobile) {
        return this.userVisible;
      } else {
        return true;
      }
    },
    closeBox: function closeBox() {
      this.showBindingBox = false;
    },
    getNoticeList: function getNoticeList() {
      var _this = this;
      CommomApi.getNotice().then(function (res) {
        if (res && res.length > 0) {
          var localNotice = localStorage.getObject('notice');
          if (!localNotice || localNotice.length === 0) {
            _this.$refs.newNotice.isShowNew = true;
            _this.$refs.newNotice.noticeList = res;
          } else {
            var showRes = res.filter(function (item) {
              return !localNotice.some(function (localItem) {
                return item.id == localItem;
              });
            });
            if (showRes.length > 0) {
              _this.$refs.newNotice.isShowNew = true;
              _this.$refs.newNotice.noticeList = showRes;
            }
          }
        }
        var noticeids = [];
        res.forEach(function (item) {
          noticeids.push(item.id);
        });
        localStorage.setObject('notice', noticeids);
      })["catch"](function (err) {});
    },
    focusBox: function focusBox() {
      if (this.inputFlag) {
        this.$refs['select-chain'].blur();
      }
    },
    handlehideMore: function handlehideMore() {
      if (this.isMobile && this.$refs.more) {
        if (this.$refs.more.show) {
          this.$refs.more.show = false;
        }
      }
    },
    closesBox: function closesBox() {
      this.showPopupBox = false;
    },
    handleSwitch: function handleSwitch() {
      this.closesBox();
      this.$store.commit('setConnectChain', false);
      this.$store.commit('setConnectChain', true);
      this.$refs.connect.showConnect = true;
      this.$refs.connect.isSelectNet = true;
    },
    getTosAgree: function getTosAgree() {
      var _this2 = this;
      if (this.$store.state.account) {
        SigninApi.getTosIsAgree({
          walletaddress: this.$store.state.account
        }).then(function (res) {
          if (!res.isAgree) {
            if (_this2.$route.path.indexOf('/docs') == -1) {
              _this2.$refs.term.isShowTerms = true;
              _this2.$refs.term.tosId = res.tosId;
            }
          } else {
            if (_this2.$store.state.showConnectIsQuery) {
              _this2.finishConnect();
            }
          }
        })["catch"](function (err) {});
      }
    },
    finishConnect: function finishConnect() {
      if (this.$store.state.contentBox) {
        this.$store.commit('setShowConnectCallBack1', false);
        this.$store.commit('setShowConnectCallBack1', true);
      } else {
        this.$store.commit('setShowConnectCallBack', false);
        this.$store.commit('setShowConnectCallBack', true);
      }
      this.$store.commit('setShowConnectIsQuery', false);
    },
    getGasPrice: function getGasPrice() {
      var _this3 = this;
      this.getChainGasPrice();
      this.timer = setInterval(function () {
        _this3.getChainGasPrice();
      }, 60000);
    },
    getChainGasPrice: function getChainGasPrice() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var provider, gasPrice, gas;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this4.$store.state.provider) {
                _context.next = 11;
                break;
              }
              provider = new ethers.providers.Web3Provider(_this4.$store.state.provider);
              _context.next = 4;
              return provider.getGasPrice();
            case 4:
              gasPrice = _context.sent;
              // await provider.getBlock()
              gas = ethers.utils.formatUnits(gasPrice.toString(), 'gwei');
              gas = Number(gas) + 1.5;
              if (gas > 10) {
                gas = BigNumber(gas).toFixed(0);
              } else if (gas > 1) {
                gas = BigNumber(gas).toFixed(1);
              } else if (gas > 0.01) {
                gas = BigNumber(gas).toFixed(2);
              } else if (gas > 0.0001) {
                gas = BigNumber(gas).toFixed(4);
              }
              _this4.gasPrice = gas;
              _context.next = 12;
              break;
            case 11:
              _this4.gasPrice = 0;
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleSearchInput: function handleSearchInput() {
      if (this.searchName) {
        // this.$refs.search.isShow = true
        // this.$refs.search.search(this.searchName)
      } else {
        // this.$refs.search.isShow = false
        // this.$refs.search.nameList = []
      }
    },
    handleToSearch: function handleToSearch() {
      this.$toUrl('/');
    },
    handleSearchName: function handleSearchName(name, e) {
      var _this5 = this;
      this.searchName = name;
      var str = /^0x[0-9a-fA-F]{40}$/;
      if (str.test(name)) {
        this.nameListItem = [{
          name: name,
          is_address: true
        }];
        this.is_address = true;
        return;
      } else {
        // this.nameList = []
        this.is_address = false;
      }
      if (!e) {
        this.resInfo();
      }
      if (name) {
        var param = _objectSpread({
          label: name,
          tld: ''
        }, this.searchParmes);
        this.loadMore = true;
        QueryApi.search(param).then(function (res) {
          _this5.loadMore = false;
          res.resultList.forEach(function (item) {
            item.tld = '.' + item.domainSuffix;
            var length = item.name.length - item.tld.length;
            item.prefix = item.name.substring(0, length);
            _this5.nameListItem.push(item);
          });
          if (_this5.searchParmes.pageSize != res.resultList.length) {
            _this5.searchLoad = false;
          } else {
            _this5.searchLoad = true;
          }
          if (res.result) {
            res.result.tld = '.' + res.result.domainSuffix;
            var length = res.result.name.length - res.result.tld.length;
            res.result.prefix = res.result.name.substring(0, length);
            _this5.nameListItem.unshift(res.result);
            if (res.resultList.length == _this5.searchParmes.pageSize - 1 || res.resultList.length == _this5.searchParmes.pageSize) {
              _this5.searchLoad = true;
            }
          }
          _this5.nameListItem = _this5.uniqueItem(_this5.nameListItem, 'name');
          _this5.$nextTick(function () {
            if (!_this5.selectDom) {
              _this5.selectDom = document.querySelector('.single-select-loadmore .el-select-dropdown__wrap');
              if (_this5.selectDom) {
                _this5.selectDom.addEventListener('scroll', _this5.handleScroll);
              }
            }
          });
        })["catch"](function (err) {
          var _err$data;
          if (err && err !== null && err !== void 0 && (_err$data = err.data) !== null && _err$data !== void 0 && _err$data.code) {
            _this5.queryErrorMsg = _this5.$t("message.err_".concat(err.data.code));
          }
        });
      } else {
        this.nameListItem = [];
      }
    },
    handleSelectName: function handleSelectName(val, item) {
      var _this6 = this;
      if (this.disabledItem(item)) {
        return;
      }
      this.nameListItem.forEach(function (item) {
        if (val == item.name) {
          _this6.getOptionItem(item);
        }
      });
    },
    handleSelectNameFocus: function handleSelectNameFocus() {
      this.userVisible = false;
    },
    handleMore: function handleMore(address) {
      if (this.is_address) {
        this.$refs['select-name'].blur();
        if (address != this.$store.state.account) {
          var dat = address;
          if (address == 1) {
            dat = this.searchName;
          }
          this.$router.push({
            path: '/nameView',
            query: {
              address: dat
            }
          });
        } else {
          this.$router.push({
            path: '/myName'
          });
        }
        return;
      }
      if (this.isMobile) {
        this.$refs.more.show = !this.$refs.more.show;
        this.userVisible = false;
      } else if (this.searchName) {
        this.$router.push({
          path: '/',
          query: {
            name: this.searchName
          }
        });
      }
    },
    handleClosesBox: function handleClosesBox() {
      // this.registerShowItem = false
      this.$store.commit('setRegisterDomainItem', {});
      this.$store.commit('setRegisterShowItem', false);
    },
    handleShow: function handleShow() {
      this.handHideCard();
      this.handHideUserPopup();
    },
    handShowFavorite: function handShowFavorite() {
      this.handleShow();
      this.$router.push('/favorite');
    },
    handShowCard: function handShowCard() {
      // this.handleShow()
      this.showCart = true;
      this.shopVisible = true;
    },
    handleShowUser: function handleShowUser(e) {
      this.handHideCard();
      if (!e) {
        this.userVisible = !this.userVisible;
        if (this.isMobile && this.$refs.more.show) {
          this.$refs.more.show = false;
        }
      }
    },
    handleClose: function handleClose() {
      this.emailVisible = false;
    },
    settingEmail: function settingEmail(e, i) {
      this.handHideUserPopup();
      if (e == 3) {
        this.emailEdit = true;
      } else {
        this.emailEdit = false;
      }
      if (i) {
        this.infoStatus = true;
      } else {
        this.infoStatus = false;
      }
      this.emailVisible = true;
    },
    handHideUserPopup: function handHideUserPopup() {
      this.userVisible = false;
    },
    handHideCard: function handHideCard() {
      var _this7 = this;
      this.shopVisible = false;
      setTimeout(function () {
        _this7.showCart = false;
      }, 1000);
    },
    handRouter: function handRouter(path, item) {
      if (path) {
        this.$router.push(path);
        if (this.shopVisible || this.userVisible) {
          this.handleShow();
        }
      } else {
        window.open(item.url);
      }
    },
    handleChangeLanguage: function handleChangeLanguage() {
      var _this8 = this;
      // this.$refs["select-lan"].focus();
      var that = this;
      this.languageList.forEach(function (item) {
        if (item.value == _this8.languageType) {
          that.$i18n.locale = item.value;
          localStorage.setItem('language', item.value);
          _this8.$store.commit('setLanguge', item.value);
        }
      });
    },
    handleVisibleChange: function handleVisibleChange(visible) {
      var _this9 = this;
      this.isSelectChainFocus = visible;
      if (!this.isSelectChainFocus) {
        this.$nextTick(function () {
          _this9.$refs['select-chain'].blur();
        });
      }
      setTimeout(function () {
        _this9.inputFlag = visible;
      }, 100);
    },
    handleSelectChain: function handleSelectChain(chainId) {
      if (this.isMobile) {
        this.showPopover = false;
      }
      this.isSelectChainFocus = false;
      if (chainId == this.$store.state.chainid && this.$store.state.token) {
        return;
      }

      //已连接钱包直接切换
      if (this.$store.state.provider) {
        switchChain(chainId);
      }
    },
    handleChangeChainId: function handleChangeChainId() {
      this.handleShow();
      this.$refs.connect.showConnect = true;
    },
    handleConnect: function handleConnect() {
      this.handleShow();
      if (!this.$store.state.account) {
        this.$refs.connect.showConnect = true;
      } else {
        this.userVisible = true;
      }
    },
    handleSwitchChainConfirm: function handleSwitchChainConfirm() {
      this.$refs.chainTip.visible = false;
      this.$store.commit('setShowConnect', true);
    }
  }
};